import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createTextVNode as _createTextVNode, createBlock as _createBlock, normalizeClass as _normalizeClass, resolveDirective as _resolveDirective, withDirectives as _withDirectives } from "vue"

const _hoisted_1 = { class: "ev-reserve-transactions" }
const _hoisted_2 = {
  key: 0,
  class: "group-header"
}
const _hoisted_3 = ["title"]
const _hoisted_4 = ["title"]
const _hoisted_5 = {
  key: 0,
  class: "description"
}
const _hoisted_6 = {
  key: 0,
  class: "date"
}
const _hoisted_7 = {
  key: 0,
  class: "transaction-details"
}
const _hoisted_8 = { class: "detail-row" }
const _hoisted_9 = { class: "value" }
const _hoisted_10 = { class: "detail-row" }
const _hoisted_11 = { class: "value" }
const _hoisted_12 = { class: "detail-row" }
const _hoisted_13 = { class: "value" }
const _hoisted_14 = { class: "detail-row" }
const _hoisted_15 = { class: "value" }
const _hoisted_16 = { class: "detail-row" }
const _hoisted_17 = { class: "value" }
const _hoisted_18 = { class: "detail-row" }
const _hoisted_19 = { class: "value" }
const _hoisted_20 = { class: "detail-row" }
const _hoisted_21 = { class: "value" }
const _hoisted_22 = { class: "detail-row" }
const _hoisted_23 = { class: "value" }
const _hoisted_24 = { class: "detail-row" }
const _hoisted_25 = { class: "value" }

import { ref, onMounted, computed } from 'vue'
import { useRouter } from 'vue-router'
import { DateTime } from 'luxon'
import type { EvReserveTransaction } from '@/types/ev'
import * as userApi from '@/api/user'

interface Props {
  transactions: EvReserveTransaction[]
  loading?: boolean
}


export default /*@__PURE__*/_defineComponent({
  __name: 'EvReserveTransactionsTable',
  props: {
    transactions: {},
    loading: { type: Boolean, default: false }
  },
  setup(__props: any) {

const props = __props

const showDetailsDialog = ref(false)
const selectedTransaction = ref<EvReserveTransaction | null>(null)

const getTypeColor = (type: string) => {
  switch (type) {
    case 'freeze':
      return 'warning'
    case 'charge':
      return 'success'
    case 'refund':
      return 'info'
    case 'reverse':
      return 'danger'
    default:
      return 'default'
  }
}

const getStatusColor = (status: string) => {
  switch (status) {
    case 'completed':
      return 'success'
    case 'pending':
      return 'warning'
    case 'failed':
      return 'danger'
    case 'canceled':
      return 'info'
    default:
      return 'default'
  }
}

const getAmountColor = (type: string) => {
  switch (type) {
    case 'freeze':
      return 'amount-freeze'
    case 'charge':
      return 'amount-charge'
    case 'refund':
      return 'amount-refund'
    default:
      return ''
  }
}

const formatAmount = (amount: number | null) => {
  if (amount === null || amount === undefined) return '0.00'
  return Number(amount).toFixed(2)
}

const formatDate = (dateString: string) => {
  if (!dateString) return '-'
  return DateTime.fromISO(dateString).toFormat('MMM dd, yyyy HH:mm')
}

const router = useRouter()

const viewDetails = (transaction: EvReserveTransaction) => {
  selectedTransaction.value = transaction
  showDetailsDialog.value = true
}

const goToUser = (userId: string) => {
  router.push(`/ev-users/${userId}`)
}

const userNames = ref<Record<string, string>>({})

const groupedTransactions = computed(() => {

  // Якщо props.transactions - це об'єкт з data, витягуємо data
  const transactions = Array.isArray(props.transactions)
    ? props.transactions
    : (props.transactions as any)?.data || []

  if (!Array.isArray(transactions)) {
    console.warn('⚠️ Transactions is not an array:', transactions)
    return []
  }

  const groups: Array<{
    reserveId: string
    transactions: EvReserveTransaction[]
    isGroupHeader?: boolean
  }> = []

  const grouped = (transactions as EvReserveTransaction[]).reduce((acc, transaction) => {

    const reserveId = transaction.ev_reserve_id || 'unknown'

    if (!acc[reserveId]) {
      acc[reserveId] = []
    }
    acc[reserveId].push(transaction)
    return acc
  }, {} as Record<string, EvReserveTransaction[]>)


  Object.entries(grouped).forEach(([reserveId, transactions]) => {
    groups.push({
      reserveId,
      transactions: [],
      isGroupHeader: true
    })

    transactions.forEach(transaction => {
      groups.push({
        reserveId,
        transactions: [transaction],
        isGroupHeader: false
      })
    })
  })

  return groups
})

const getUserName = (transaction: EvReserveTransaction) => {
  const userName = userNames.value[transaction.user_id]
  return userName || `User ${transaction.user_id}`
}

const loadUserNames = async () => {
  try {
    const transactions = Array.isArray(props.transactions)
      ? props.transactions
      : (props.transactions as any)?.data || []

    const userIds = [...new Set((transactions as EvReserveTransaction[]).map(t => t.user_id))]

    for (const userId of userIds) {
      if (!userNames.value[userId]) {
        try {
          const response = await userApi.getUserDetails(userId)
          const user = response.data.data
          userNames.value[userId] = `${user.first_name || ''} ${user.last_name || ''}`.trim() || `User ${userId}`
        } catch (error) {
          console.error(`Failed to load user ${userId}:`, error)
          userNames.value[userId] = `User ${userId}`
        }
      }
    }
  } catch (error) {
    console.error('Failed to load user names:', error)
  }
}

onMounted(() => {

  const transactions = Array.isArray(props.transactions)
    ? props.transactions
    : (props.transactions as any)?.data || []

  if (Array.isArray(transactions) && transactions.length > 0) {
    loadUserNames()
  } else {
    console.warn('⚠️ No transactions to load user names for')
  }
})

return (_ctx: any,_cache: any) => {
  const _component_el_table_column = _resolveComponent("el-table-column")!
  const _component_el_tag = _resolveComponent("el-tag")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_table = _resolveComponent("el-table")!
  const _component_el_dialog = _resolveComponent("el-dialog")!
  const _directive_loading = _resolveDirective("loading")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _withDirectives((_openBlock(), _createBlock(_component_el_table, {
      data: groupedTransactions.value,
      style: {"width":"100%"}
    }, {
      default: _withCtx(() => [
        _createVNode(_component_el_table_column, {
          label: "ID",
          prop: "id",
          width: "200"
        }, {
          default: _withCtx(({ row }) => [
            (row.isGroupHeader)
              ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
                  _createElementVNode("span", {
                    class: "reserve-id",
                    title: row.reserveId
                  }, "Reservation #" + _toDisplayString(row.reserveId.substring(0, 8)), 9, _hoisted_3)
                ]))
              : (_openBlock(), _createElementBlock("span", {
                  key: 1,
                  class: "transaction-id",
                  title: row.transactions[0]?.id
                }, _toDisplayString(row.transactions[0]?.id.substring(0, 8)), 9, _hoisted_4))
          ]),
          _: 1
        }),
        _createVNode(_component_el_table_column, {
          label: "Type",
          width: "100"
        }, {
          default: _withCtx(({ row }) => [
            (!row.isGroupHeader)
              ? (_openBlock(), _createBlock(_component_el_tag, {
                  key: 0,
                  type: getTypeColor(row.transactions[0]?.type),
                  size: "small"
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(row.transactions[0]?.type), 1)
                  ]),
                  _: 2
                }, 1032, ["type"]))
              : _createCommentVNode("", true)
          ]),
          _: 1
        }),
        _createVNode(_component_el_table_column, {
          label: "Status",
          width: "120"
        }, {
          default: _withCtx(({ row }) => [
            (!row.isGroupHeader)
              ? (_openBlock(), _createBlock(_component_el_tag, {
                  key: 0,
                  type: getStatusColor(row.transactions[0]?.status),
                  size: "small"
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(row.transactions[0]?.status), 1)
                  ]),
                  _: 2
                }, 1032, ["type"]))
              : _createCommentVNode("", true)
          ]),
          _: 1
        }),
        _createVNode(_component_el_table_column, {
          label: "Amount",
          width: "120"
        }, {
          default: _withCtx(({ row }) => [
            (!row.isGroupHeader)
              ? (_openBlock(), _createElementBlock("span", {
                  key: 0,
                  class: _normalizeClass(["amount", getAmountColor(row.transactions[0]?.type)])
                }, _toDisplayString(formatAmount(row.transactions[0]?.amount_scr)) + " ₼ ", 3))
              : _createCommentVNode("", true)
          ]),
          _: 1
        }),
        _createVNode(_component_el_table_column, {
          label: "Description",
          "min-width": "200"
        }, {
          default: _withCtx(({ row }) => [
            (!row.isGroupHeader)
              ? (_openBlock(), _createElementBlock("span", _hoisted_5, _toDisplayString(row.transactions[0]?.description || '-'), 1))
              : _createCommentVNode("", true)
          ]),
          _: 1
        }),
        _createVNode(_component_el_table_column, {
          label: "Date",
          width: "160"
        }, {
          default: _withCtx(({ row }) => [
            (!row.isGroupHeader)
              ? (_openBlock(), _createElementBlock("span", _hoisted_6, _toDisplayString(formatDate(row.transactions[0]?.created_at)), 1))
              : _createCommentVNode("", true)
          ]),
          _: 1
        }),
        _createVNode(_component_el_table_column, {
          label: "Actions",
          width: "100",
          fixed: "right"
        }, {
          default: _withCtx(({ row }) => [
            (!row.isGroupHeader)
              ? (_openBlock(), _createBlock(_component_el_button, {
                  key: 0,
                  type: "primary",
                  size: "small",
                  onClick: ($event: any) => (viewDetails(row.transactions[0]))
                }, {
                  default: _withCtx(() => _cache[2] || (_cache[2] = [
                    _createTextVNode(" Details ")
                  ])),
                  _: 2,
                  __: [2]
                }, 1032, ["onClick"]))
              : _createCommentVNode("", true)
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["data"])), [
      [_directive_loading, _ctx.loading]
    ]),
    _createVNode(_component_el_dialog, {
      modelValue: showDetailsDialog.value,
      "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((showDetailsDialog).value = $event)),
      title: "Transaction Details",
      width: "600px"
    }, {
      default: _withCtx(() => [
        (selectedTransaction.value)
          ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
              _createElementVNode("div", _hoisted_8, [
                _cache[3] || (_cache[3] = _createElementVNode("span", { class: "label" }, "ID:", -1)),
                _createElementVNode("span", _hoisted_9, _toDisplayString(selectedTransaction.value.id), 1)
              ]),
              _createElementVNode("div", _hoisted_10, [
                _cache[4] || (_cache[4] = _createElementVNode("span", { class: "label" }, "Type:", -1)),
                _createElementVNode("span", _hoisted_11, [
                  _createVNode(_component_el_tag, {
                    type: getTypeColor(selectedTransaction.value.type)
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(selectedTransaction.value.type), 1)
                    ]),
                    _: 1
                  }, 8, ["type"])
                ])
              ]),
              _createElementVNode("div", _hoisted_12, [
                _cache[5] || (_cache[5] = _createElementVNode("span", { class: "label" }, "Status:", -1)),
                _createElementVNode("span", _hoisted_13, [
                  _createVNode(_component_el_tag, {
                    type: getStatusColor(selectedTransaction.value.status)
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(selectedTransaction.value.status), 1)
                    ]),
                    _: 1
                  }, 8, ["type"])
                ])
              ]),
              _createElementVNode("div", _hoisted_14, [
                _cache[6] || (_cache[6] = _createElementVNode("span", { class: "label" }, "Amount:", -1)),
                _createElementVNode("span", _hoisted_15, _toDisplayString(formatAmount(selectedTransaction.value.amount_scr)) + " ₼ ", 1)
              ]),
              _createElementVNode("div", _hoisted_16, [
                _cache[7] || (_cache[7] = _createElementVNode("span", { class: "label" }, "Currency:", -1)),
                _createElementVNode("span", _hoisted_17, _toDisplayString(selectedTransaction.value.currency), 1)
              ]),
              _createElementVNode("div", _hoisted_18, [
                _cache[8] || (_cache[8] = _createElementVNode("span", { class: "label" }, "User:", -1)),
                _createElementVNode("span", _hoisted_19, [
                  _createVNode(_component_el_button, {
                    type: "text",
                    onClick: _cache[0] || (_cache[0] = ($event: any) => (goToUser(selectedTransaction.value.user_id))),
                    class: "user-link"
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(getUserName(selectedTransaction.value)), 1)
                    ]),
                    _: 1
                  })
                ])
              ]),
              _createElementVNode("div", _hoisted_20, [
                _cache[9] || (_cache[9] = _createElementVNode("span", { class: "label" }, "Description:", -1)),
                _createElementVNode("span", _hoisted_21, _toDisplayString(selectedTransaction.value.description || '-'), 1)
              ]),
              _createElementVNode("div", _hoisted_22, [
                _cache[10] || (_cache[10] = _createElementVNode("span", { class: "label" }, "Created:", -1)),
                _createElementVNode("span", _hoisted_23, _toDisplayString(formatDate(selectedTransaction.value.created_at)), 1)
              ]),
              _createElementVNode("div", _hoisted_24, [
                _cache[11] || (_cache[11] = _createElementVNode("span", { class: "label" }, "Updated:", -1)),
                _createElementVNode("span", _hoisted_25, _toDisplayString(formatDate(selectedTransaction.value.updated_at)), 1)
              ])
            ]))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }, 8, ["modelValue"])
  ]))
}
}

})